import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { APP_HOME_PATH } from "@/lib/copilot-home";

export function GuiaGuard() {
  const { workspaces, activeWorkspaceId } = useAuth();
  const guiaEnabled = workspaces.find(w => w.organization_id === activeWorkspaceId)?.guia_enabled ?? false;
  if (!guiaEnabled) return <Navigate to={APP_HOME_PATH} replace />;
  return <Outlet />;
}
